
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {},
  "env": "release",
  "buildInfo": {
    "version": "2.0.0-bridge.1",
    "time": 1784779725876,
    "commit": "e2d51c9f18c46f2cfb095f8fcf9321070ff19f90",
    "shortCommit": "e2d51c9",
    "branch": "HEAD",
    "env": "release"
  },
  "una": {
    "primary": "yellow",
    "gray": "stone",
    "radius": 0.5,
    "fontSize": 16
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/opt/buildhome/repo/app/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
